import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { IoLocationOutline } from "react-icons/io5";
import { FiPhoneCall } from "react-icons/fi";
import { LuMail } from "react-icons/lu";
import ContactImg from "../../assets/images/contact2.jpg";
const ContactForm = () => {
  return (
    <section className="contactform">
      <Container>
        <Row>
          <Col lg={6}>
            <div className="contactform-left">
              <h5>Get In Touch</h5>
              <h3>We’re here to help!</h3>
              <p>
                If you have any questions about your order, products, or
                anything else — just reach out and we'll get back to you as soon
                as possible.
              </p>
              <form>
                <Row>
                  <Col md={6}>
                    <div className="form-group">
                      <label htmlFor="name">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        placeholder="Enter your name"
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="form-group">
                      <label htmlFor="email">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder="Enter your email"
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="form-group">
                      <label htmlFor="phone">Phone</label>
                      <input
                        type="tel"
                        className="form-control"
                        id="phone"
                        name="phone"
                        placeholder="Enter your phone"
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="form-group">
                      <label htmlFor="orderNumber">Order Number</label>
                      <input
                        type="text"
                        className="form-control"
                        id="orderNumber"
                        name="orderNumber"
                        placeholder="Enter your order number"
                      />
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="form-group">
                      <label htmlFor="message">How can we help you?</label>
                      <textarea
                        className="form-control"
                        id="message"
                        name="message"
                        placeholder="Enter your message"
                        rows="5"
                      ></textarea>
                    </div>
                  </Col>
                  <Col lg={4} md={5} sm={5} xs={6}>
                    <button type="submit" className="submit-btn">
                      Send Message
                    </button>
                  </Col>
                </Row>
              </form>
            </div>
          </Col>
          <Col lg={6}>
            <div className="contactform-right">
                <div className="person-img">
                    <img src={ContactImg} alt="person" loading="lazy" />
                </div>
              <div className="contact-list">
                <ul>
                  <li>
                    <a href="tel:+971503580352">
                      <span className="contact-list-icon">
                        <FiPhoneCall />
                      </span>
                      <div className="contact-list-text">
                        <h5>Phone</h5>
                        <p>+971503580352</p>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="mailto:carapglobal@gmail.com">
                      <span className="contact-list-icon">
                        <LuMail />
                      </span>
                      <div className="contact-list-text">
                        <h5>Mail</h5>
                        <p>carapglobal@gmail.com</p>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="https://maps.app.goo.gl/QHws3sc3UYzvFPH4A" target="_blank" rel="noopener noreferrer">
                      <span className="contact-list-icon">
                        <IoLocationOutline />
                      </span>
                      <div className="contact-list-text">
                        <h5>Address</h5>
                        <p>4-5 AL kebbesi, Deire, Dubai United Arab Emirates</p>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              {/* <div className="footer-map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.526672904456!2d-115.08032492430716!3d36.20143650122309!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c8dcd943d22061%3A0x459300c7ee27126e!2sLa%20Puente%20St%2C%20Sunrise%20Manor%2C%20NV%2089115%2C%20USA!5e1!3m2!1sen!2sin!4v1761549676412!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div> */}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactForm;
